<template>
  <header
    class="bg-white border-gray-200 border-b relative lg:static lg:overflow-y-visible z-10000"
  >
    <div class="max-w-7xl mx-auto py-1 px-4 sm:px-6 lg:px-8">
      <!-- the dash header uses this slot to override the default nav -->
      <slot name="navigation">
        <DefaultNavigation>
          <!-- slot to fill buttons -->
          <slot />
        </DefaultNavigation>
      </slot>
    </div>
  </header>
</template>

<script>
import DefaultNavigation from '@/components/DefaultNavigation'

export default {
  components: { DefaultNavigation },
}
</script>
